import { ExportButton, TopToolbar } from "react-admin";
import * as React from "react";
export const ListActions = props => {
  return (
    <TopToolbar {...props}>
      <ExportButton
        resource={props.resource}
        sort={props.currentSort}
        filterValues={props.filterValues}
        maxResults={10000}
      />
    </TopToolbar>
  );
};
export default ListActions;
